var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8031 6.67123C11.8305 6.64485 11.8585 6.61918 11.887 6.59424C11.4508 6.21235 10.8894 6 10.3061 6H8.99431C8.35779 6 7.74734 6.25286 7.29725 6.70294L6.25167 7.74853C6.02662 7.97357 5.7214 8.1 5.40314 8.1H1.7002V14.7H5.55314C5.8714 14.7 6.17662 14.8264 6.40167 15.0515L8.66077 17.3106C9.1022 17.752 9.70091 18 10.3252 18C10.9495 18 11.5482 17.752 11.9896 17.3106L12.2002 17.1L12.5627 17.4021C12.91 17.6915 13.3478 17.85 13.7998 17.85C14.3123 17.85 14.8038 17.6464 15.1662 17.284L15.5002 16.95C16.2545 16.95 16.9637 16.5906 17.4098 15.9823L17.8927 15.3239C18.1474 14.9765 18.0795 14.4895 17.7395 14.225L12.9502 10.5M11.8031 6.67123L9.76127 8.63748C9.04122 9.33086 9.03038 10.4802 9.73722 11.187C10.4347 11.8845 11.5656 11.8845 12.2632 11.187L12.9502 10.5M11.8031 6.67123C12.2504 6.24059 12.847 6 13.4679 6H16.0061C16.6426 6 17.2531 6.25286 17.7031 6.70294L18.7487 7.74853C18.9738 7.97357 19.279 8.1 19.5973 8.1H23.3002V14.7H18.3502L12.9502 10.5M12.9502 10.5L14.3002 9.15M1.7002 8.11758H4.1002V14.7176H1.7002V8.11758ZM20.9002 8.11758H23.3002V14.7176H20.9002V8.11758Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeal);
export default __webpack_public_path__ + "static/media/deal.38fe7671.svg";
export { ForwardRef as ReactComponent };